// Display formatters copied from the reference admin's Vue directives
// (v-odds, v-kval, v-kvalsportmin/max, v-fancybook). Display only.

/** v-odds: 0 shows an em dash, anything else is shown as-is (fancy odds are runs, not decimals). */
export const formatOdds = (odds) => (Number(odds) === 0 || odds == null ? '—' : odds)

/** v-kval: >= 1000 → "<n.n>K". */
export const formatSize = (size) => {
  const n = Number(size)
  if (n >= 1e3) return `${parseFloat((n / 1e3).toFixed(1))}K`
  return parseFloat(n)
}

/** v-kvalsportmin / v-kvalsportmax: 1e3..1e5 → "K", >= 1e5 → "L" (lakh). */
export const formatSportLimit = (value) => {
  const n = Number(Number(value || 0).toFixed(2))
  if (n >= 1e3 && n < 1e5) return `${parseFloat((n / 1e3).toFixed(2))}K`
  if (n >= 1e5) return `${parseFloat((n / 1e5).toFixed(2))}L`
  return parseFloat(n)
}

/** v-fancybook: value formatted en-IN, coloured green when positive, red otherwise. */
export const formatBook = (book) => {
  const n = Number(book || 0)
  return n ? n.toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 2 }) : 0
}
export const bookColor = (book) => (Number(book || 0) > 0 ? 'green' : 'red')

/** Reference: row is suspended when the section's gscode != 1 (fallback: gstatus text). */
export const isSectionSuspended = (section) =>
  section.gscode != null
    ? Number(section.gscode) !== 1
    : String(section.gstatus || '').toUpperCase() === 'SUSPENDED'

/** Reference orders sections by sno (stable). */
export const sortSections = (sections) =>
  sections
    .map((s, i) => [s, i])
    .sort((a, b) => (Number(a[0].sno) || 0) - (Number(b[0].sno) || 0) || a[1] - b[1])
    .map(([s]) => s)
